export const alphabetRegex = /^[A-Za-z]+(\s[A-Za-z]+)*$/;
export const cityFieldRegex = /^[A-Za-z]+([ .]+[A-Za-z]+)*$/;
export const personNameRegex = /^[A-Za-z](?:[A-Za-z\s-]*[A-Za-z])?\s*$/;
export const alphabetCountyRegex = /^[A-Za-zñáéíóúü]+(\s[A-Za-zñáéíóúü]+)*$/;
export const facilityNameRegex = /^[A-Za-z](?:[A-Za-z\s'-]*[A-Za-z])?$/;
export const alphabetOnlyRegex = /^[a-zA-Z]*$/;
export const alphabetSpaceAndHyphen = /[^a-zA-Z\s-]/g;
export const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const numberOnlyRegex = /^\d+$/;
export const validNonZeroNumber = /^[1-9]\d*$/;
export const numAlphabetOnlyRegex = /^[A-Za-z0-9]*$/;
export const alphaNumericRegex = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;
export const anyCharacters = /^[!-~]*$/;
export const phoneFaxFormat = /^\([1-9]\d{2}\) \d{3}-\d{4}$/;
export const contractIdPbpRegex = /^[A-Za-z0-9](?:[A-Za-z0-9\s-]*[A-Za-z0-9])?$/;
export const onlyNumAlphabetRegex = /[^A-Za-z0-9]/g;
export const addressRegex = /[a-z]/i;
export const mbiRegex = /^\d[A-Za-z][A-Za-z\d]\d[A-Za-z][A-Za-z\d]\d[A-Za-z]{2}\d{2}$/;
export const physicianNameRegex = /^\(?[A-Za-z](?:[A-Za-z\s.\-()]*[A-Za-z])?\)?\s*$/;
export const alphanumericHyphenUnderscore = /^[a-zA-Z0-9_-]+$/;
export const textHighlighter = /\[([^\]]+?)\]/g;
export const patientNameRegex = /^[A-Za-z0-9_\-'.]+( [A-Za-z0-9_\-'.]+)*$/;